import { render, staticRenderFns } from "./tSale.vue?vue&type=template&id=295ff804&scoped=true"
import script from "./tSale.vue?vue&type=script&lang=js"
export * from "./tSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295ff804",
  null
  
)

export default component.exports